module.exports = __webpack_public_path__ + "img/user-avatar.676052fe.png";